import { TFunction } from "i18next";

import {
  IEntityRelationsRow,
  RydeAppUnit,
  RydeUiUnit,
  TEntityRelationsMap,
} from "@ryde/shared";

export const getShowRelatedEntitiesTooltipText = ({
  t,
  entity,
  entityId,
}: {
  t: TFunction;
  entity: RydeUiUnit;
  entityId: number;
}): string => {
  const entityName = t(`${entity}.single`);

  return t("general.SHOW_RELATED_ENTITIES_OF", {
    entity: entityName,
    id: entityId,
  });
};

export const mapRelationsMapToRows = (
  relationsMap: TEntityRelationsMap,
  hasReadPermission: (relationEntity: RydeUiUnit) => boolean,
): IEntityRelationsRow[] =>
  Object.entries(relationsMap)
    .filter(([relationEntity]) =>
      hasReadPermission(relationEntity as RydeUiUnit),
    )
    .map(([relation, items]) => ({
      relation,
      ids: items.map(item => Number(item.id)),
    }))
    .sort((a, b) => a.relation.localeCompare(b.relation));

export const getRelatedEntitiesExcelFilename = (
  entity: RydeUiUnit,
  entityId: number,
): string => `related_entities_${entity}_${entityId}.xlsx`;

export const openRelatedEntityEdit = async ({
  relation,
  id,
  onCloseAction,
  openRideEditFormDrawer,
  openBookingEditFormDrawer,
  openEditFormDrawer,
}: {
  relation: string;
  id: number;
  onCloseAction: () => void;
  openRideEditFormDrawer: (args: {
    id: number;
    onCloseAction: () => void;
  }) => Promise<unknown>;
  openBookingEditFormDrawer: (args: {
    id: number;
    onCloseAction: () => void;
  }) => Promise<unknown>;
  openEditFormDrawer: (args: {
    id: number;
    entity: RydeAppUnit;
    onCloseAction: () => void;
  }) => Promise<unknown>;
}): Promise<void> => {
  switch (relation) {
    case "ride":
      await openRideEditFormDrawer({ id, onCloseAction });
      break;
    case "booking":
      await openBookingEditFormDrawer({ id, onCloseAction });
      break;
    default:
      await openEditFormDrawer({
        id,
        entity: relation as RydeAppUnit,
        onCloseAction,
      });
  }
};
